import { render, staticRenderFns } from "./pendingapproval.vue?vue&type=template&id=6d3bf042"
import script from "./pendingapproval.vue?vue&type=script&lang=js"
export * from "./pendingapproval.vue?vue&type=script&lang=js"
import style0 from "./pendingapproval.vue?vue&type=style&index=0&id=6d3bf042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports